import(/* webpackMode: "eager", webpackExports: ["ConciergeWidget"] */ "/vercel/path0/src/components/client-portal/dashboard/ConciergeWidget.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["PortalLayout"] */ "/vercel/path0/src/components/client-portal/PortalLayout.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["PortalLayoutClient"] */ "/vercel/path0/src/components/client-portal/PortalLayoutClient.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["Sidebar"] */ "/vercel/path0/src/components/client-portal/Sidebar.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["AnimatedCounter"] */ "/vercel/path0/src/components/client-portal/ui/AnimatedCounter.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["Bookings"] */ "/vercel/path0/src/components/client-portal/views/Bookings.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["Dashboard"] */ "/vercel/path0/src/components/client-portal/views/Dashboard.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["Enquiries"] */ "/vercel/path0/src/components/client-portal/views/Enquiries.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["MyDeals"] */ "/vercel/path0/src/components/client-portal/views/MyDeals.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["MyFeedback"] */ "/vercel/path0/src/components/client-portal/views/MyFeedback.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["MyOffers"] */ "/vercel/path0/src/components/client-portal/views/MyOffers.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["MyProposals"] */ "/vercel/path0/src/components/client-portal/views/MyProposals.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["MySavedSearches"] */ "/vercel/path0/src/components/client-portal/views/MySavedSearches.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["OrderDetailView"] */ "/vercel/path0/src/components/client-portal/views/OrderDetail.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["OrderHistory"] */ "/vercel/path0/src/components/client-portal/views/OrderHistory.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["Profile"] */ "/vercel/path0/src/components/client-portal/views/Profile.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["SavedProperties"] */ "/vercel/path0/src/components/client-portal/views/SavedProperties.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["SpacesView"] */ "/vercel/path0/src/components/client-portal/views/SpacesView.tsx");
